import React from 'react'
import eventManager from '../../helpers/eventManager'
import history from '../../helpers/history'

class MessageContainer extends React.Component
{
    state = {
        errors: [],
        success: [],
        info: []
    }

    createMessage = (data) =>
    {
        window.scrollTo(0, 0)
        if (data.type === "error") {
            this.setState({ errors: data.message })
        }

        else if (data.type === "success") {
            this.setState({ success: data.message })
        }

        else if (data.type === "info") {
            this.setState({ info: data.message })
        }
    }

    clearMessages = () =>
    {
        this.setState({ success: [], errors: [], info: [] })
    }

    componentDidMount()
    {

        eventManager.listenEvent("MESSAGE", "create message", this.createMessage.bind(this))
        eventManager.listenEvent("MESSAGE-CLEAR", "clear messages", this.clearMessages.bind(this))

        let messageContainer = this
        
        history.listen((location) =>
        {
            messageContainer.clearMessages()
        })
    }

    render()
    {
        return (
            <React.Fragment>
                {
                    this.state.errors.map((error) =>
                    {
                        if (error){
                            return <div class="alert-container pt-2"><div class = "alert alert-danger">{error}</div></div>
                        }
                    })
                }
                {
                    this.state.success.map((success) =>
                    {
                        if (success){
                            return <div class="alert-container pt-2"><div class = "alert alert-success">{success}</div></div>
                        }
                    })
                }
                {
                    this.state.info.map((info) =>
                    {
                        if (info) {
                            return <div class="alert-container pt-2"><div class = "alert alert-info">{info}</div></div>
                        }
                    })
                }
            </React.Fragment>
        )
    }
}

export default MessageContainer
